module.exports = __webpack_public_path__ + "static/media/iconLibrarySchool.11058031.svg";